import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
// import settings from './modules/settings'
import user from './modules/user'
// import widget from './modules/widget'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    // settings,
    user,
    // widget
  },
  getters
})

export default store
